import { render, staticRenderFns } from "./ButtonList.vue?vue&type=template&id=5d6f5d86&scoped=true"
import script from "./ButtonList.vue?vue&type=script&lang=ts"
export * from "./ButtonList.vue?vue&type=script&lang=ts"
import style0 from "./ButtonList.vue?vue&type=style&index=0&id=5d6f5d86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6f5d86",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CBtn: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/content/c-btn.vue').default})
